import SniperRange from './SniperRange.js';
import manifest from './manifest.js';
import type { GameRuntimeFactory } from '@adgf/game-engine';

export { default as SniperRange } from './SniperRange.js';
export { default as manifest } from './manifest.js';

export const createRuntime: GameRuntimeFactory = (config, events) => {
  return new SniperRange(config, events);
};

export default manifest;
